import styled from "styled-components";

export const BackgroundMessage = styled.div`
/* border: 1px solid red; */
`

export const Message = styled.p`
font-size: 12px;
color: red;
`